module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Extrabld.994af2687321f73123daa6cd3a62c7ca.ttf";